module.exports = __webpack_public_path__ + "static/media/chart-line-down.0defc025.svg";